import transformSchemaResponse from './transformSchemaResponse';
import makeUniqueFilename from './makeUniqueFilename';

// TODO: create a bulk endpoint in roost so we don't call the network in a loop
export default async function fetchAllSchemas({
  reports,
  cluster,
  earliestSeen,
  getSchemaDetails,
  onProgress,
  shouldCancel,
}) {
  const schemaFiles = {};
  const usedFilenames = new Set();

  for (let index = 0; index < reports.length; index++) {
    if (shouldCancel()) return null;

    onProgress(index);

    const report = reports[index];
    const response = await getSchemaDetails({
      clusterId: cluster.id,
      earliestSeen,
      eventName: report.eventName,
      writekeys: report.pipelines.map(p => p.writekey),
    });

    const properties = transformSchemaResponse(response);
    if (properties) {
      const filename = makeUniqueFilename(report.eventName, usedFilenames);
      usedFilenames.add(filename);
      schemaFiles[`${filename}.json`] = JSON.stringify(properties, null, 2);
    }
  }

  return schemaFiles;
}
